module.exports = __webpack_public_path__ + "96b2dea937ed1870c743b83ad274fd9d.png";